import { SnapshotOut } from 'mobx-state-tree';
import DavisSensor from './model';

export interface IDavisSensorOut extends SnapshotOut<typeof DavisSensor> {}

export default DavisSensor;
